exports.components = {
  "component---src-campaigns-diabetamina-jsx": () => import("./../../../src/campaigns/diabetamina.jsx" /* webpackChunkName: "component---src-campaigns-diabetamina-jsx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-main-al-jsx": () => import("./../../../src/pages/main-al.jsx" /* webpackChunkName: "component---src-pages-main-al-jsx" */)
}

